import React, { useEffect } from "react";
import EnvConfig from "../config/env.config";
import { getSkippIdentityToken } from "../apis/user/get.skipp.identity.token";
import { ClientStorage, ClientStorageItem } from "../utils/clientstorage";


declare global {
  interface Window {
    SkippWidget?: {
      open: () => void;
      close: () => void;
      toggle: () => void;
    };
  }
}

export const SkippWidgetLoader: React.FC = () => {
  useEffect(() => {
    const scriptUrl = EnvConfig.skippScriptUrl || "https://cdn.skipp.cx/widget.js";
    const workspaceId = EnvConfig.skippWorkspaceId;
    const apiBaseUrl = EnvConfig.skippApiBaseUrl || "https://api.skipp.cx";
    const token = ClientStorage.fetch(ClientStorageItem.AccessToken);

    if (!workspaceId) return;

    // Fetch signed identity token for authenticated user
    if (token) {
      getSkippIdentityToken({
        onCompleted: ({ data }) => {
          if (data?.token && data?.workspaceId) {
            localStorage.setItem(
              `skipp-widget-identity-token:${data.workspaceId}`,
              data.token
            );
          }
        },
        onError: (err) => {
          console.warn("Could not fetch Skipp identity token", err);
        },
      });
    }

    // Check if script is already injected
    const scriptId = "skipp-widget-script";
    if (document.getElementById(scriptId)) return;

    const cleanApiBaseUrl = apiBaseUrl.replace(/\/$/, "");
    const script = document.createElement("script");
    script.id = scriptId;
    script.src = scriptUrl;
    script.async = true;
    script.dataset.workspaceId = workspaceId;
    script.dataset.apiBaseUrl = cleanApiBaseUrl;
    script.setAttribute("data-workspace-id", workspaceId);
    script.setAttribute("data-api-base-url", cleanApiBaseUrl);

    document.body.appendChild(script);

  }, []);


  return null;
};

export default SkippWidgetLoader;
